import { motion } from "framer-motion";
import { Instagram, MessageCircle } from "lucide-react";
import { site, waLink } from "@/content/siteContent";

const fabClass =
  "relative flex h-14 w-14 items-center justify-center rounded-full border border-metal bg-graphite shadow-[0_14px_34px_-10px_rgba(0,0,0,0.85)] transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-brand/70";

export default function WhatsAppFab() {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-5 right-5 z-[60] flex flex-col gap-3 md:bottom-7 md:right-7"
    >
      <a
        href={site.instagram}
        target="_blank"
        rel="noopener noreferrer"
        className={fabClass}
        aria-label="Abrir Instagram da Sagarelo"
        data-testid="instagram-fab"
      >
        <Instagram className="h-6 w-6 text-paper" />
        <span className="absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full border-2 border-coal bg-brand" />
      </a>
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        className={fabClass}
        aria-label="Conversar no WhatsApp"
        data-testid="whatsapp-fab"
      >
        <span className="absolute inset-0 animate-ping rounded-full border border-brand/25 [animation-duration:2.6s]" />
        <MessageCircle className="h-6 w-6 text-paper" />
        <span className="absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full border-2 border-coal bg-brand" />
      </a>
    </motion.div>
  );
}
